<script lang="ts">
  // Static header component - no props needed
</script>

<header class="bg-white border-b border-solid border-[#f0f2f4] sticky top-0 z-50">
  <div class="layout-container flex justify-center w-full">
    <div class="flex max-w-[1280px] flex-1 items-center justify-between px-4 py-3 md:px-10">
      <div class="flex items-center gap-4 text-[#111418]">
        <div class="size-8 text-primary flex items-center justify-center">
          <span class="material-symbols-outlined text-3xl">calculate</span>
        </div>
        <h2 class="text-[#111418] text-lg font-bold leading-tight tracking-[-0.015em]">EazyCalculators</h2>
      </div>

      <!-- Desktop Nav -->
      <div class="hidden md:flex flex-1 justify-end gap-8 items-center">
        <a class="text-[#111418] text-sm font-medium hover:text-primary transition-colors" href="/">Dashboard</a>
        <!-- Commented out for initial release
        <div class="flex items-center gap-6 lg:gap-9">
          <a class="text-[#111418] text-sm font-medium hover:text-primary transition-colors" href="#">Dashboard</a>
          <a class="text-[#111418] text-sm font-medium hover:text-primary transition-colors" href="#">Saved Calculations</a>
          <a class="text-[#111418] text-sm font-medium hover:text-primary transition-colors" href="#">Profile</a>
        </div>
        <div class="flex items-center gap-4">
          <div
            class="bg-center bg-no-repeat aspect-square bg-cover rounded-full size-10 border border-gray-200 bg-gray-100 flex items-center justify-center"
          >
            <span class="material-symbols-outlined text-gray-400">person</span>
          </div>
          <button class="flex min-w-[84px] cursor-pointer items-center justify-center overflow-hidden rounded-lg h-9 px-4 bg-white border border-gray-200 text-[#111418] hover:bg-gray-50 text-sm font-bold transition-all">
            <span class="truncate">Sign Out</span>
          </button>
        </div>
        -->
      </div>

      <!-- Mobile Menu Icon -->
      <div class="md:hidden text-[#111418]">
        <span class="material-symbols-outlined">menu</span>
      </div>
    </div>
  </div>
</header>
